export default "__VITE_ASSET__CzHjvZwn__"